<template>
  <v-avatar
    v-if="user && user.clientprofile.avatar_image_url"
    :size="size"
  >
    <!-- Note: Query param is for cache busting in Chrome, to ensure the
    img src updates when new data arrives.-->
    <img :src="user.clientprofile.avatar_image_url + '?' + Math.random()">
  </v-avatar>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    size: {
      type: Number,
      default: 96,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UserAvatarImage.vue